import React from 'react';
import CuadroListaEditable from '../edicion/CuadroListaEditable.js';
import * as Data from '../edicion/data/DataPersonaLinks.js';
import * as DTOs from '../edicion/DTOs/LinksPersonaDTOs.js';
import * as Funciones from '../edicion/funciones/FuncionesLinks.js';

const LinksPersona = (props) => {
  const idPersona = props.persona && props.persona.id;

  return (
    <CuadroListaEditable
      titulo="Links"
      idPadre={idPersona}
      data={Data}
      dtos={DTOs}
      funciones={Funciones}
      ocultarSiVacio={true}
    />
  );
};

export default LinksPersona;
